module.exports = __webpack_public_path__ + "static/scan.c43234e8.svg";